<template>
  <div>
    <div class="row">
      <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
        <div class="card">
          <div class="card-body">
            <p
              style="
                font-size: 16px;
                font-weight: bold;
                text-align: center;
                margin-bottom: 16px;
              "
            >
              Términos y Condiciones
            </p>

            <!-- Loading State -->
            <div v-if="loading" class="loading-container">
              <div class="text-center">
                <div class="spinner-border text-primary" role="status">
                  <span class="visually-hidden">Cargando...</span>
                </div>
                <p class="mt-2">Cargando documento...</p>
              </div>
            </div>

            <!-- PDF Viewer Container -->
            <div v-else-if="pdfUrl" class="pdf-container">
              <iframe
                :src="pdfUrl"
                width="100%"
                :style="{
                  height: iframeHeight + 'px',
                  border: 'none',
                  borderRadius: '8px',
                }"
                title="Descripción general Saludsa"
                @load="onPdfLoad"
                @error="onPdfError"
              ></iframe>
            </div>

            <!-- Error State -->
            <div v-else-if="error" class="error-container">
              <div class="text-center">
                <i
                  class="fas fa-exclamation-triangle text-warning"
                  style="font-size: 48px"
                ></i>
                <p class="mt-2 text-danger">{{ error }}</p>
                <button @click="loadPdf" class="btn btn-primary">
                  <i class="fas fa-redo me-2"></i>
                  Reintentar
                </button>
              </div>
            </div>

            <!-- Fallback for mobile if iframe doesn't work -->
            <div v-if="isMobile && pdfUrl" class="mobile-fallback mt-3">
              <p
                style="font-size: 14px; text-align: center; margin-bottom: 16px"
              >
                Si no puedes ver el documento, puedes descargarlo aquí:
              </p>
              <div class="text-center">
                <a
                  :href="pdfUrl"
                  target="_blank"
                  class="btn btn-primary"
                  style="text-decoration: none"
                >
                  <i class="fas fa-download me-2"></i>
                  Descargar Descripción
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/*eslint-disable */

export default {
  name: "Descripcion",
  data() {
    return {
      isMobile: this.$isMobile,
      loading: true,
      error: null,
      pdfUrl:
        "https://firebasestorage.googleapis.com/v0/b/saludsapro.appspot.com/o/legalDocuments%2FTyCs_RefiereyGana_Saludsa_Ecija_rCEV.pdf?alt=media&token=7adbf25f-5531-49ab-b56a-bd0217206fb7",
      iframeHeight: 600, // Default height for the iframe
    };
  },
  methods: {
    loadPdf() {
      // Since we're using a direct URL, we just need to set loading to false
      this.loading = false;
      this.error = null;
    },

    onPdfLoad() {
      console.log("PDF loaded successfully");
      this.loading = false;
    },

    onPdfError() {
      this.error = "Error al cargar el documento PDF.";
      this.loading = false;
    },

    calculateIframeHeight() {
      // Get viewport height
      const viewportHeight = window.innerHeight;
      // Subtract header, padding, and other elements (adjust these values as needed)
      const headerHeight = 80; // Approximate header height
      const padding = 100; // Padding and margins
      const titleHeight = 60; // Title and card padding

      this.iframeHeight = viewportHeight - headerHeight - padding - titleHeight;

      // Ensure minimum height
      if (this.iframeHeight < 400) {
        this.iframeHeight = 400;
      }
    },
  },

  activated() {
    if (this.isMobile) {
      this.$eventBus.emit("inactiveShowMenu");
    }
    this.calculateIframeHeight();
  },

  mounted() {
    this.calculateIframeHeight();

    // Add resize listener
    window.addEventListener("resize", this.calculateIframeHeight);

    // Set a timeout to handle cases where iframe events don't fire
    setTimeout(() => {
      if (this.loading) {
        this.loading = false;
      }
    }, 3000);
  },

  beforeUnmount() {
    // Remove resize listener
    window.removeEventListener("resize", this.calculateIframeHeight);
  },
};
</script>

<style scoped>
.loading-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 400px;
}

.pdf-container {
  position: relative;
  width: 100%;
  background-color: #f8f9fa;
  border-radius: 8px;
  overflow: hidden;
}

.pdf-container iframe {
  width: 100%;
  border: none;
  border-radius: 8px;
}

.error-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 400px;
  padding: 20px;
}

/* Mobile responsive adjustments */
@media (max-width: 768px) {
  .mobile-fallback {
    padding: 16px;
    background-color: #f8f9fa;
    border-radius: 8px;
  }

  .loading-container,
  .error-container {
    min-height: 300px;
  }
}
</style>
